import { useNavigate } from 'react-router-dom';
import { useCreateDocumentary } from '@/hooks';
import { CreateDocumentaryRequest } from '@/types/model';
import DocumentaryForm from '@/components/forms/DocumentaryForm';
import Button from '@/components/ui/Button.tsx';
import toast from 'react-hot-toast';

const CreateDocumentary = () => {
  const navigate = useNavigate();
  const createDocumentaryMutation = useCreateDocumentary();

  const handleSuccess = async (data: CreateDocumentaryRequest) => {
    try {
      await createDocumentaryMutation.mutateAsync(data);
      toast.success('Documentary created successfully');
      navigate(-1);
    } catch (error) {
      console.error('Create error:', error);
      toast.error(error instanceof Error ? error.message : 'Unexpected error');
      throw error; // Re-throw to let form handle the error
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-4">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          onClick={handleCancel}
          variant="link"
        >
          ← Volver a la lista
        </Button>

        <DocumentaryForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          isSubmitting={createDocumentaryMutation.isPending}
        />
      </div>
    </div>
  );
};

export default CreateDocumentary;
